// WhatsApp text formatting markers
export const formatMarkers = {
  bold: '*',
  italic: '_',
  strikethrough: '~',
};

export const applyTextFormat = ({ text, start, end, formatType }) => {
  if (!text || start === end || !formatType) return null;

  const marker = formatMarkers[formatType];
  if (!marker) return null;

  const selectedText = text.substring(start, end);
  const isFormatted = selectedText.startsWith(marker) && selectedText.endsWith(marker);
  const beforeText = text.substring(0, start);
  const afterText = text.substring(end);

  let newText;
  let newStart;
  let newEnd;

  if (isFormatted) {
    // Remove formatting
    newText = beforeText + selectedText.substring(1, selectedText.length - 1) + afterText;
    newStart = start;
    newEnd = end - 2;
  } else {
    // Add formatting
    newText = beforeText + marker + selectedText + marker + afterText;
    newStart = start;
    newEnd = end + 2;
  }

  return {
    text: newText,
    selectionStart: newStart,
    selectionEnd: newEnd,
  };
};
